import { type UseQueryResult, useQuery } from 'react-query';
import { type TableParamsType } from '../../types/common';
import {
  PagedResultDto_ProductionItemDto,
  ProductionService,
} from '../../services/wealthlane-identity-services';

const useGetSandboxProductionList = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  tableInfo: TableParamsType
): UseQueryResult<
  // eslint-disable-next-line camelcase
  PagedResultDto_ProductionItemDto | undefined,
  unknown
> => {
  const { filter, sorting, skipCount, maxResultCount } = tableInfo;

  const getSandboxProductionList = useQuery(
    ['getSandboxProductionList', filter, sorting, skipCount, maxResultCount],
    async () => {
      return await handleRequest(
        ProductionService.getApiIdentityApiProduction(filter, sorting, skipCount, maxResultCount)
      );
    }
  );

  return getSandboxProductionList;
};

export default useGetSandboxProductionList;
